module.exports = __webpack_public_path__ + "img/BI.b92d3598.svg";